module.exports = __webpack_public_path__ + "static/media/ic_hdfc_logo.25bfc3a6.svg";